// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__pea63","img":"styles_img__YTfi0","data":"styles_data__bU58H"};